<template>
	<div>
  	<!-- Teachers -->
  	<!-- Información básica del grupo -->
		<v-card class="mx-auto transparent elevation-0">
			<v-card-text>
				<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
				Teachers
				</div>
			</v-card-text>
		</v-card>

		<v-card class="elevation-0 shadowCard mb-4" v-if="getGrupo.teachers.teacher1">
			<v-card-text>
				<v-row fill-height>
					<v-col cols="9" class="d-flex align-center">
						<div>
							<p class="mb-0 text-body-1 ">
								<strong>{{ getGrupo.teachers.teacher1 }}</strong>
							</p>
						</div>
					</v-col>
					<v-col cols="3" class="d-flex justify-end">
						<v-avatar
						size="50"
						color="transparent"
						rounded
						class="shadowCard"
						>
							<avataaars
							v-if="getGrupo.teachers.avatar_t1"
							:accessoriesType="getGrupo.teachers.avatar_t1.accessoriesType"
								:isCircle="true"
								:clotheType="getGrupo.teachers.avatar_t1.clotheType"
								:clotheColor="getGrupo.teachers.avatar_t1.clotheColor"
								:eyebrowType="getGrupo.teachers.avatar_t1.eyebrowType"
								:eyeType="getGrupo.teachers.avatar_t1.eyeType"
								:facialHairColor="getGrupo.teachers.avatar_t1.facialHairColor"
								:facialHairType="getGrupo.teachers.avatar_t1.facialHairType"
								:graphicType="getGrupo.teachers.avatar_t1.graphicType"
								:mouthType="getGrupo.teachers.avatar_t1.mouthType"
								:skinColor="getGrupo.teachers.avatar_t1.skinColor"
								:topType="getGrupo.teachers.avatar_t1.topType"
								:topColor="getGrupo.teachers.avatar_t1.topColor"
								:hairColor="getGrupo.teachers.avatar_t1.hairColor"
								:circleColor="'#6fb8e0'">
							</avataaars>
							<avataaars v-else></avataaars>
						</v-avatar>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	  		
		<v-card class="elevation-0 shadowCard" v-if="getGrupo.teachers.teacher2">
			<v-card-text>
				<v-row>
					<v-col cols="3">
            <v-avatar
	            size="50"
	            color="transparent"
	            rounded
	            class="shadowCard"
	          >
	          	<avataaars
	            	v-if="getGrupo.teachers.avatar_t2"
		          	:accessoriesType="getGrupo.teachers.avatar_t2.accessoriesType"
			        	:isCircle="true"
					      :clotheType="getGrupo.teachers.avatar_t2.clotheType"
			        	:clotheColor="getGrupo.teachers.avatar_t2.clotheColor"
					      :eyebrowType="getGrupo.teachers.avatar_t2.eyebrowType"
					      :eyeType="getGrupo.teachers.avatar_t2.eyeType"
					      :facialHairColor="getGrupo.teachers.avatar_t2.facialHairColor"
			        	:facialHairType="getGrupo.teachers.avatar_t2.facialHairType"
					      :graphicType="getGrupo.teachers.avatar_t2.graphicType"
					      :mouthType="getGrupo.teachers.avatar_t2.mouthType"
			        	:skinColor="getGrupo.teachers.avatar_t2.skinColor"
			        	:topType="getGrupo.teachers.avatar_t2.topType"
			        	:topColor="getGrupo.teachers.avatar_t2.topColor"
					      :hairColor="getGrupo.teachers.avatar_t2.hairColor"
					      :circleColor="'#6fb8e0'">
					    </avataaars>
					    <avataaars v-else></avataaars>
	          </v-avatar>
					</v-col>

					<v-col cols="9" class="d-flex justify-end align-center">
						<div>
							<p class="mb-0 text-body-1">
	              				<strong>{{ getGrupo.teachers.teacher2 }}</strong>
	            			</p>
	          			</div>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'
	import Avataaars from 'vuejs-avataaars'

	export default {
		components:{
  		Avataaars,
  	},

	  name: "dashboard-default",
	  data: () => ({

	  }),


	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS' ])
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirCalificaciones' ] ),
	  	
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

	.recursos{
		background: rgb(233,186,255);
		background: linear-gradient(90deg, rgba(233,186,255,1) 0%, rgba(186,52,251,1) 100%);
	}

	.calificaciones{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.colorCurso{
		color: #006093;
	}

</style>
